import { render, staticRenderFns } from "./PrivacyLayout.vue?vue&type=template&id=744edfad"
import script from "./PrivacyLayout.vue?vue&type=script&lang=js"
export * from "./PrivacyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports